import { supabase } from './supabase';

export interface FeedbackSubmission {
  feedbackType: 'bug' | 'feature' | 'general' | 'other';
  subject: string;
  message: string;
  pageUrl?: string;
  userAgent?: string;
}

/**
 * Submit feedback to the database and send email notification
 * This will store the feedback and send an email to support@pinkdolphincards.com
 */
export async function submitFeedback(feedback: FeedbackSubmission): Promise<{ success: boolean; error?: string }> {
  try {
    // Get current user if authenticated
    const { data: { user } } = await supabase.auth.getUser();
    
    // Get page URL and user agent
    const pageUrl = window.location.href;
    const userAgent = navigator.userAgent;
    
    // Call the Supabase function to submit feedback to database
    const { data: feedbackData, error: dbError } = await supabase.rpc('submit_feedback', {
      p_feedback_type: feedback.feedbackType,
      p_subject: feedback.subject,
      p_message: feedback.message,
      p_user_id: user?.id || null,
      p_user_email: user?.email || null,
      p_page_url: pageUrl,
      p_user_agent: userAgent,
    });

    if (dbError) {
      console.error('Error submitting feedback to database:', dbError);
      return { success: false, error: dbError.message };
    }

    // If feedback was saved successfully, send email notification
    if (feedbackData && feedbackData.id) {
      try {
        // Call the Edge Function to send email using Supabase functions API
        // Use Supabase's functions client which handles CORS automatically
        const { error: emailError } = await supabase.functions.invoke('send-feedback-email', {
          body: {
            feedbackId: feedbackData.id,
            userId: user?.id || null,
            userEmail: user?.email || null,
            feedbackType: feedback.feedbackType,
            subject: feedback.subject,
            message: feedback.message,
            pageUrl: pageUrl,
            userAgent: userAgent,
          },
        });

        if (emailError) {
          console.warn('Failed to send email notification:', emailError);
          // Still return success since feedback was saved to database
          // Email failure shouldn't block the user from submitting feedback
        }
      } catch (emailError: any) {
        console.warn('Error calling email function:', emailError);
        // Still return success since feedback was saved to database
      }
    }

    return { success: true };
  } catch (error: any) {
    console.error('Error submitting feedback:', error);
    return { success: false, error: error.message || 'Failed to submit feedback' };
  }
}

